export default "__VITE_ASSET__CspECBEX__";